module.exports = __webpack_public_path__ + "img/grami.19e1c416.jpg";